<footer class="real-footer fixed-bottom">
  <div class="text-white py-1">
    <div class="container-fluid">
      <div class="row d-flex justify-content-between align-items-center text-center">
        
        <div class="col-lg-4 col-md-6 col-12 mb-2"><p class="mb-0 josefin-sans-regular">© <b>{{ currentYear }}</b> All rights reserved to <a href="" class="text-white text-decoration-none font-weight-bold">
          வேல் மாறல் சேவா அறக்கட்டளை.
        </a></p></div>
        <div class="col-lg-4 col-md-6 col-12 mb-2 justify-content-between align-items-center text-center"><p
           class="mb-0">Designed &amp; Developed by <a
           href="https://cktechsoln.in/" target="_blank"
          class="text-white text-decoration-none font-weight-bold">CKTech Solution Pvt Ltd Madurai.</a></p></div>
          <div class="col-lg-4 col-md-6 col-12 mb-2 justify-content-between align-items-center text-center"><p
           class="mb-0"><a
           routerLink="/terms" target="_blank"
          class="text-white text-decoration-none font-weight-bold">Terms & Conditions</a> | <a
           routerLink="/privacy" target="_blank"
          class="text-white text-decoration-none font-weight-bold">Privacy</a></p></div>
      </div>
    </div>
  </div>

</footer>